import CheckedIcon from '../../assests/svg/checked_icon.svg';
import alertIcon from '../../assests/svg/alert_icon.svg';
import crossRedIcon from '../../assests/svg/cross-red.svg';

export type FeasibilityStatusScheama = {
  [key: string]: { src: string; title: string; address?: string };
};

export const FEASIBILITY_STATUS_SCHEMA = {
  FEASIBLE: 'FEASIBLE',
  MANUAL_INTERVENTION_REQUIRED: 'MANUAL_INTERVENTION_REQUIRED',
  NOT_FEASIBLE: 'NOT_FEASIBLE',
  EXPIRED: 'EXPIRED',
  PENDING: 'PENDING'
};

export const FeasibilityStatus: FeasibilityStatusScheama = {
  FEASIBLE: { src: CheckedIcon, title: 'Network Availability Status: Feasible' },
  MANUAL_INTERVENTION_REQUIRED: { src: alertIcon, title: 'Network Availability Status: Manual network check is required for this site.' },
  NOT_FEASIBLE: { src: crossRedIcon, title: 'Network Availability Status: Not Feasible' },
  EXPIRED: { src: alertIcon, title: 'Network Availability Status: Expired' }
};
